<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search"
        >
            <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>Users</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>                
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" v-if="$store.state.currentPagePriv.create">
                      New User
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <span>Username</span>
                            <v-text-field v-model="editedItem.username" filled rounded dense hide-details="auto" @keydown.space.prevent :readonly="editedIndex>-1" :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Full Name</span>
                            <v-text-field v-model="editedItem.fullname" filled rounded dense hide-details="auto" :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Password</span>
                            <v-text-field v-if="editedIndex>-1" v-model="editedItem.password" filled rounded dense hide-details="auto"></v-text-field>
                            <v-text-field v-else :rules="reqRule" v-model="editedItem.password" filled rounded dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Email</span>
                            <v-text-field v-model="editedItem.email" filled rounded dense hide-details="auto" :rules="emailRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Role</span>
                            <v-select filled rounded dense :items="roles" item-text="role_name" item-value="code" v-model="editedItem.role_code" :rules="reqRule"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <span>Group</span>
                          <v-select filled rounded dense :items="groups" item-text="name" item-value="code" v-model="editedItem.group"></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <span>Outlets</span>
                          <v-select filled rounded dense :items="outlets" item-text="name" item-value="code" v-model="editedItem.outlets" multiple chips small-chips deletable-chips hide-details="auto"></v-select>
                        </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                        Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                        Save
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="body-1 text-center">Anda akan menghapus user ini?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDetail" max-width="600px">
                <v-card>
                    <v-card-title class="">
                    <span class="text-h6">User Detail</span>
                    <v-spacer></v-spacer>
                    <v-icon color="white" @click="dialogDetail = false">mdi-close</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-4">
                    <v-container>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Username:</v-col>
                          <v-col cols="8">{{ detailItem.username }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Full Name:</v-col>
                          <v-col cols="8">{{ detailItem.fullname }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Email:</v-col>
                          <v-col cols="8">{{ detailItem.email }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Role:</v-col>
                          <v-col cols="8">{{ getRoleName(detailItem.role_code) }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Group:</v-col>
                          <v-col cols="8">{{ getGroupName(detailItem.group) }}</v-col>
                        </v-row>
                    </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogDetail = false">
                        Close
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-toolbar>
            </template>
            <template v-slot:[`item.group`]="{ item }">
                {{ getGroupName(item.group) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="viewDetail(item)">
                mdi-eye
            </v-icon>
            <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                mdi-delete
            </v-icon>
            </template>
            <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
                Reset
            </v-btn>
            </template>
            <template v-slot:[`item.role_code`]="{ item }">
                {{getRoleName(item.role_code)}}
            </template>
        </v-data-table>
    </div>
</template>

<script>

  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      dialogDetail: false,
      detailItem: {},
      headers: [
        { text: 'Username', value: 'username' },
        { text: 'Full Name', value: 'fullname' },
        { text: 'Email', value: 'email' },
        { text: 'Role', value: 'role_code' },
        { text: 'Group', value: 'group' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
      search: '',
      roles: [],
      reqRule: [v => !!v || 'Harus diisi!'],
      emailRule: [
        v => !!v || 'Harus diisi!',
        // v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      valid: true,
      groups: [
        { code: 'OP', name: 'Operational Team' },
        { code: 'NON-OP', name: 'Non Operational Team' }
      ],
      outlets: [],
      allOutlets: [],
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New User' : 'Edit User'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      'editedItem.outlets': function(newVal, oldVal) {
        // Handle "All" selection logic
        if (newVal && newVal.includes('ALL')) {
          if (!oldVal || !oldVal.includes('ALL')) {
            // "All" was just selected, select all outlets
            this.editedItem.outlets = ['ALL', ...this.allOutlets.map(o => o.code)]
          } else {
            // "All" is already selected, check if all individual items are still selected
            const withoutAll = newVal.filter(code => code !== 'ALL')
            if (withoutAll.length < this.allOutlets.length) {
              // Some items were deselected, remove "All"
              this.editedItem.outlets = withoutAll
            }
          }
        } else if (oldVal && oldVal.includes('ALL') && newVal) {
          // "All" was deselected, keep remaining selections
          const withoutAll = newVal.filter(code => code !== 'ALL')
          if (withoutAll.length < this.allOutlets.length) {
            // Some items were deselected, remove "All"
            this.editedItem.outlets = withoutAll
          }
        } else if (newVal && newVal.length === this.allOutlets.length && !newVal.includes('ALL')) {
          // All individual items selected, add "All"
          this.editedItem.outlets = ['ALL', ...newVal]
        }
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        this.roles = (await this.$store.dispatch('role/getObjs')).data.data
        let response = await this.$store.dispatch('getObjs', {apidomain:'users', parameter:''})
        if (response.data.status=='success') this.items = response.data.data
        
        // Load outlets for multi-select
        let outletResponse = await this.$store.dispatch('outlet/getObjs')
        if (outletResponse.data.status=='success') {
          this.allOutlets = outletResponse.data.data
          // Add "All" option at the beginning
          this.outlets = [
            { code: 'ALL', name: '-- Semua Outlet --' },
            ...outletResponse.data.data
          ]
        }
      },

      getRoleName(code) {
        const role = this.roles.find(element => element.code == code);
        return role ? role.role_name : '-';
      },

      viewDetail(item) {
        this.detailItem = Object.assign({}, item);
        this.dialogDetail = true;
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        console.log(this.editedIndex)
        this.editedItem = Object.assign({}, item)
        // Map outlets to array of codes for v-model
        if (item.outlets && item.outlets.length > 0) {
          this.editedItem.outlets = item.outlets.map(o => o.code)
          // Add "All" if all outlets are selected
          if (this.editedItem.outlets.length === this.allOutlets.length) {
            this.editedItem.outlets = ['ALL', ...this.editedItem.outlets]
          }
        } else {
          this.editedItem.outlets = []
        }
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        let url = this.$store.state.config.apiHost + "users/" + this.editedItem.username
        let response = await this.$axios.delete(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
        if (response.data.status=='success') this.items.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        await this.$refs.form.validate();
        if (!this.valid) return;

        // Remove "ALL" from outlets before saving
        const dataToSave = { ...this.editedItem }
        if (dataToSave.outlets && dataToSave.outlets.includes('ALL')) {
          dataToSave.outlets = dataToSave.outlets.filter(code => code !== 'ALL')
        }

        if (this.editedIndex > -1) {
          try {
            let url = this.$store.state.config.apiHost + "users/" + this.editedItem.username
            let response = await this.$axios.put(url, JSON.stringify(dataToSave), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
            if (response.data.status=='success') {
              // Update item in list with response data that includes outlets
              Object.assign(this.items[this.editedIndex], response.data.data)
            }
          }
          catch (err) {
            console.log(err)
            const keyword = 'duplicate key'
            if (err.response.data.message.search(keyword) > -1){
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Username atau Email sudah terdaftar."})
            }
            else {
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
            }
          }

          
        } else {
          try {
            let url = this.$store.state.config.apiHost + "users"
            let response = await this.$axios.post(url, JSON.stringify(dataToSave), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
            if (response.data.status=='success') {
              // Push response data that includes outlets
              this.items.push(response.data.data)
            }
          }
          catch (err) {
            console.log(err)
            const keyword = 'duplicate key'
            if (err.response.data.message.search(keyword) > -1){
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Username atau Email sudah terdaftar."})
            }
            else {
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
            }
          }

        }
        this.close()
      },
      getGroupName(code) {
        const selectedGroup = this.groups.find(g => g.code == code);
        if (selectedGroup) {
          return selectedGroup.name;
        } else {
          return '';
        }
      },
    },
  }
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

</style>